<template>
    <div>
        <div
          class="modal fade"
          id="cookieSettingsModal"
          role="dialog"
          aria-labelledby="cookieSettingsModal"
          aria-hidden="true"
        >
            <div class="modal-dialog modal-fullscreen-custom" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Configurações avançadas de cookies</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="justify-items: right;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-scroll">
                        <div>
                          <h5><strong>Última atualização: 05/11/2025</strong></h5>
                          <p>
                            Para melhorar a sua experiência na plataforma e prover serviços personalizados, utilizamos cookies. Quando você visita um site, ele pode armazenar ou coletar informações no seu navegador, principalmente na forma de cookies. Essas informações podem ser sobre você, suas preferências ou seu dispositivo e são usadas principalmente para fazer o site funcionar como você espera. As informações normalmente não o identificam diretamente, mas podem oferecer uma experiência na web mais personalizada. Como respeitamos seu direito à privacidade, você pode optar por não permitir alguns tipos de cookies. Clique nos títulos das diferentes categorias para saber mais e alterar nossas configurações padrão. No entanto, o bloqueio de alguns tipos de cookies pode afetar sua experiência no website e os serviços que podemos oferecer.
                          </p>
                        </div>
                        <hr>
                        <div>
                          <div class="sub-section">
                              <span>
                                  <h4 style="color: #6087bc;">Cookies estritamente necessários</h4>
                              </span>
                              <span>
                                  <h4 style="color:green;"><strong>Sempre ativado</strong></h4>
                              </span>
                          </div>
                          <p>
                            Esses cookies permitem funcionalidades essenciais, tais como segurança, verificação de identidade e gestão de rede. <strong>Esses cookies não podem ser desativados em nossos sistemas.</strong> Embora sejam necessários, você pode bloquear esses cookies diretamente no seu navegador, mas isso pode comprometer sua experiência e prejudicar o funcionamento do site.
                          </p>
                        </div>
                        <hr>
                        <div>
                          <div class="sub-section">
                              <span>
                                  <h4 style="color: #6087bc;">Cookies de desempenho</h4>
                              </span>
                              <span>
                                <input type="checkbox" id="allCookies" name="allCookies" checked style="accent-color: #6087bc;"/>
                                <label for="allCookies">&nbsp;&nbsp;Ativado</label>
                              </span>
                          </div>
                          <p>
                            Visam a melhoria do desempenho do site por meio da coleta de dados anonimizados sobre navegação e uso dos recursos disponibilizados. Se você não permitir a coleta desses cookies, esses dados não serão usados para melhoria do site.
                          </p>
                        </div>
                        <hr>
                        <div style="align-items: center; justify-content: center; display: flex;">
                          <label class="form-check-label" for="termos">
                            <a data-toggle="modal" class="termos" href="#modalTermos" data-dismiss="modal">
                              Declaração de Conformidade com os Princípios de Proteção de Dados
                            </a>
                          </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-success"
                            style="background-color: #6087bc; border-color: #6087bc"
                            data-dismiss="modal"
                            @click="acceptCookies()"
                            >
                            Aceitar Cookies
                        </button>
                    </div>
                </div>
            </div>
        </div>
    <TermosCondicoes></TermosCondicoes>
    </div>
</template>

<script>
import TermosCondicoes from "./TermosCondicoes.vue";

export default {
  name: "CookieConsentSettings",
  components: { TermosCondicoes },
  mounted() {
    const el = this.$el;
    document.body.appendChild(el);
  },
  methods: {
    acceptCookies() {
      const isAllCookiesChecked = document.getElementById("allCookies").checked;
      if (isAllCookiesChecked) {
        localStorage.setItem("allCookiesAccepted", "true");
        this.$emit('acceptSettings');
      } else {
        localStorage.setItem("onlyEssentialAccepted", "true");
      }
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-fullscreen-custom {
  width: 100%;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen-custom .modal-content {
  height: 100%;
  border-radius: 0;
  display: flex;
  flex-direction: column;
}

.modal-body-scroll {
  overflow-y: auto;
  flex: 1;
  padding: 1rem 1.5rem;
}

body.modal-open {
  overflow: hidden;
  padding-right: 0 !important;
}

.sub-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
